<div id="Wrapper" class="d-flex flex-column">
  <tig-header></tig-header>
  <main class="flex-fill">
    <router-outlet></router-outlet>
  </main>
  <tig-footer></tig-footer>
</div>
